import React from 'react';
import { useSelector} from 'react-redux';
import { Divider } from 'rsuite';
import {findLastUnpaidCashflow, generateAddressString, setInstallmentText}  from '../../../../../app/common/services/vehicle.service';
import {BackIcon} from '../../svg/iconsSvg';
import InsCompLogos from '../../svg/insCompLogos';

const PayInstSummary = ({onBack, onForward, policy, style}) => {

    const unpaidCashFlow = findLastUnpaidCashflow(policy?.cashflows);

    let payAmount =  Number.parseFloat(unpaidCashFlow?.dueAmount).toFixed(2);
    payAmount = Number.isNaN(parseInt(payAmount)) ? null : payAmount;

    let payAmountEUR =  Number.parseFloat(unpaidCashFlow?.dueAmountEUR).toFixed(2);
    payAmountEUR = Number.isNaN(parseInt(payAmountEUR)) ? null : payAmountEUR;

    const shipmentDetails = useSelector(state => state.shipmentDetails)
    const {receiverName , receiverPhone, receiverAddInfo, deliveryAddress} = shipmentDetails || {};

    //const {registrationProps} = policy || {};
    //const {make, model, plate} = registrationProps || {};
    //const vechicleData = make ? `${make.value} ${model?.value} ${plate?.value}` : null;

    const insCompany = policy?.insCompany;

    const CompanyLogo   = InsCompLogos[insCompany] ? InsCompLogos[insCompany]() : null;

    //console.log(userDetails)

    const goBack = () => onBack(3)

    const goForward = async (step) => {

        onForward(step);
    }

    return (
        <div className="steps_container" style={{...style, minHeight: '50vh'}}>
            <div  className="head">
                <div className="head-icon" style={{paddingLeft: '2rem'}} onClick={goBack}><BackIcon size={32}/></div>
                <h6 className="title" style={{marginRight: '48px'}}>{setInstallmentText(unpaidCashFlow)}</h6>
            </div>
            <Divider style={{marginBottom: 0 , backgroundColor: '#6bdfa7', height: '.5px'}}/>
            <div className="payment-card">
                <div className="left">
                    <p style={{marginBottom: '16px'}}>Гражданска отговорност</p>
                    <div style={"ozkins_uniqa_allianz_groupama".includes(insCompany) ? {marginLeft:'0'} : "armeetz_bulstrad".includes(insCompany) ? {marginLeft:'-.7rem'} : null}> {CompanyLogo} </div>
                    <p style={{fontSize: '14px', marginTop: '8px'}}>{policy?.policyId}</p>
                    
                </div>
                <div  className="right" >
                    <p style={{marginBottom: '8px'}}>Сума за плащане</p>
                    <p style={{fontWeight: '700', fontSize: '15px'}}>{payAmountEUR} € / {payAmount} лв.</p>
                </div>
            </div>
            
            <div className="summary-container" style={{margin: '0 0 40px 0', padding: '16px 32px'}}>
                <div className="left">
                    <p>Доставка</p>
                    <p>{receiverName}</p>
                    <p>{'+' + receiverPhone}</p>
                </div>
                <div className="right">
                    <p>{generateAddressString(deliveryAddress)}{receiverAddInfo ? `, ${receiverAddInfo}` : ''}</p>
                </div>
            </div>
   
            <button className="nuIns-btn nuIns-btn-main" type="submit" onClick={()=>goForward(5)}>Плащане с карта</button>
      
            <button className="nuIns-btn nuIns-btn-mxd nuIns-btn-outlined_2" type="submit" onClick={()=>goForward(7)}>Наложен платеж</button>
        </div>
    );
}

export default PayInstSummary;

